import { styled } from 'styled-components';

export const Wrapper = styled.div<{ $numberOfColumns: number; $disabled?: boolean }>`
  display: grid;
  grid-template-columns: repeat(${({ $numberOfColumns }) => $numberOfColumns}, minmax(0, 1fr));
`;

export const LoaderSlot = styled.div<{ $disabled?: boolean }>`
  grid-column: 1 / -1;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 36px;
  border: 1px solid ${({ theme, $disabled }) => ($disabled ? theme.colors.grey05_3 : theme.colors.grey30_1)};
  border-radius: 8px;
`;
